import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { TokenService } from './token.service';
import { AppConfigService } from '../../app-config/app-config.service';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

  constructor(
    public router: Router,
    private tokenService: TokenService,
    private appConfigService: AppConfigService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.tokenService.token$.pipe(
      switchMap(token => {
        const apiHosts = this.appConfigService.config.environmentName === 'prd'
          ? ['api.psps714.com', 'api.prd.psps714.com']
          : [`api.${this.appConfigService.config.environmentName}.psps714.com`];

        let isApiRequest = false;
        try {
          const requestHost = new URL(request.url, window.location.origin).hostname;
          isApiRequest = apiHosts.includes(requestHost);
        } catch {
          isApiRequest = false;
        }

        if (isApiRequest) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
        }
        return next.handle(request).pipe(
          catchError((error: HttpErrorResponse) => {
            switch (error.status) {
              case 401:
                this.router.navigate(['/']);
                break;
              case 403:
                this.router.navigate(['/']);
                break;
            }
            return throwError(() => error);
          })
        );
      })
    );
  }
}